module.exports = __webpack_public_path__ + "img/2_NIVEL.8f06b345.jpg";